import { setupSGWTConnect as d, EVENT_AUTH_DISCARDED as u, EVENT_AUTH_EXPIRED as g, EVENT_AUTH_RENEW_ERROR as h, EVENT_AUTH_RENEW_SUCCESS as l } from "@sgwt/connect-core";
function a(e, t, o) {
  var i;
  const n = new URL((i = e?.api.endpoint) !== null && i !== void 0 ? i : "", window.location.protocol + "//" + window.location.host);
  return n.pathname += t, o.forEach((r) => {
    n.searchParams.append(r[0], r[1]);
  }), n;
}
const p = {
  get: (e, t, o, i) => {
    var n;
    const r = (n = i.sgConnect) === null || n === void 0 ? void 0 : n.getAuthorizationHeader();
    if (r) {
      const c = a(i.appConfig, e, t);
      return fetch(c.href, {
        method: "GET",
        headers: new Headers({
          Authorization: r,
          "X-Client-Scope": i.clientScopeCode
        }),
        signal: o
      });
    }
    return Promise.reject(new Error("No Authorization found"));
  },
  post: (e, t, o, i, n) => {
    var r;
    const c = (r = n.sgConnect) === null || r === void 0 ? void 0 : r.getAuthorizationHeader();
    if (c) {
      const s = a(n.appConfig, e, t);
      return fetch(s.href, {
        method: "POST",
        headers: new Headers({
          Authorization: c,
          "X-Client-Scope": n.clientScopeCode,
          "Content-Type": "application/json"
        }),
        body: JSON.stringify(o),
        signal: i
      });
    }
    return Promise.reject(new Error("No Authorization found"));
  },
  put: (e, t, o, i, n) => {
    var r;
    const c = (r = n.sgConnect) === null || r === void 0 ? void 0 : r.getAuthorizationHeader();
    if (c) {
      const s = a(n.appConfig, e, t);
      return fetch(s.href, {
        method: "PUT",
        headers: new Headers({
          Authorization: c,
          "X-Client-Scope": n.clientScopeCode,
          "Content-Type": "application/json"
        }),
        body: JSON.stringify(o),
        signal: i
      });
    }
    return Promise.reject(new Error("No Authorization found"));
  },
  patch: (e, t, o, i, n) => {
    var r;
    const c = (r = n.sgConnect) === null || r === void 0 ? void 0 : r.getAuthorizationHeader();
    if (c) {
      const s = a(n.appConfig, e, t);
      return fetch(s.href, {
        method: "PATCH",
        headers: new Headers({
          Authorization: c,
          "X-Client-Scope": n.clientScopeCode,
          "Content-Type": "application/json"
        }),
        body: JSON.stringify(o),
        signal: i
      });
    }
    return Promise.reject(new Error("No Authorization found"));
  },
  delete: (e, t, o, i) => {
    var n;
    const r = (n = i.sgConnect) === null || n === void 0 ? void 0 : n.getAuthorizationHeader();
    if (r) {
      const c = a(i.appConfig, e, t);
      return fetch(c.href, {
        method: "DELETE",
        headers: new Headers({
          Authorization: r,
          "X-Client-Scope": i.clientScopeCode
        }),
        signal: o
      });
    }
    return Promise.reject(new Error("No Authorization found"));
  }
}, S = "global.language";
function E() {
  const e = window.SGWTWidgetConfiguration;
  return e && e.bus ? e.bus : null;
}
function f(e) {
  return document.querySelector(e);
}
const w = (e) => {
  let t = d({
    authorization_endpoint: e.sgConnect.endPoint,
    client_id: e.sgConnect.clientId,
    redirect_uri: e.publicBaseUrl + "silent_renew.html",
    scope: e.sgConnect.scopes,
    acr_values: e.sgConnect.level
  });
  return t.on && (t.on(u, () => {
    console.info("Token is no longer available on the client side.");
  }), t.on(g, () => {
    console.info("Token is no longer valid.");
  }), t.on(h, (o) => {
    console.error("Failed to renew the token", o);
  }), t.on(l, () => {
    console.info("A fresh token has been acquired.");
  })), t;
};
function v(e) {
  window.SGWTWidgetConfiguration.environment = e.sgConnect.SGWTWidgetConfiguration.environment, console.info("SGWTWidgetConfiguration set to: ", e.sgConnect.SGWTWidgetConfiguration.environment);
}
function A(e) {
  const t = w(e), o = f("sgwt-connect");
  if (o)
    if (typeof o.setSgwtConnectInstance > "u") {
      const i = () => {
        o.setSgwtConnectInstance(t), console.info("widget is initialized, removing sgwt-connect--ready listener...", o.sgwtConnect), o.removeEventListener("sgwt-connect--ready", i);
      };
      o.addEventListener("sgwt-connect--ready", i);
    } else
      o.setSgwtConnectInstance(t), console.info("widget is initialized", o.sgwtConnect);
  return t;
}
class T {
}
export {
  S as BUS_TOPIC_GLOBALLANGUAGE,
  p as Http,
  T as SgwtWidgetDummyModule,
  E as getWidgetBus,
  A as setupSgwtConnectWidget,
  v as setupWidgetConfiguration
};
//# sourceMappingURL=main.es.js.map
